import { RequestHelper,IResponse,IResponseWithData } from "../libs/request-helper";
import {Utils} from "../utils";
import {MagazineReuestDto} from "../dtos/magazine-home-request-dto";
import { MagazineHomeResponseDto } from "../dtos/magazine-home-response-dto";
import {MagazineEntryDto} from "../dtos/magazine-entry-dto";
import {ItemRender} from "../renderer/magazine/item-renderer"
import {ErrorRenderer} from "../renderer/error-renderer";
import {BookRenderer} from "../renderer/home/book-renderer";
import {NewsletterRenderer} from "../renderer/home/newsletter-renderer";
import {ScheduleRenderer} from "../renderer/home/schedule-renderer";
import {HomeItemRenderer} from "../renderer/home/home-item-renderer";
import {VideoRenderer} from "../renderer/home/video-renderer";
import {ImageOverlayHelper} from "../libs/image-overlay-helper";
import { Home } from './home';

declare var Hyphenator:any;

export class ActiveHome extends Home{
	protected static requestUrl = "/wp-content/themes/enfold-schauspielhaus/json/active-magazine.php";
	protected static ERROR_MSG = "Es konnten leider keine Schauspielhaus Aktiv Einträge gefunden werden!";
	

	protected static onDocumentLoaded() {
		ActiveHome.requestDto = new MagazineReuestDto();
		ActiveHome.requestDto.isHome = true;
		ActiveHome.loadData();
	}

	public static async init():Promise<void> {
		Home.dataContainer = <HTMLElement>document.getElementById("p_homeData");
		Home.errorRenderer = new ErrorRenderer(ActiveHome.dataContainer,ActiveHome.ERROR_MSG);
		document.addEventListener('DOMContentLoaded', ActiveHome.onDocumentLoaded, false);
	}

	protected static renderHero(hero: MagazineEntryDto){
		var heroWrapper = document.createElement("div");
		heroWrapper.classList.add("sshgWidget_heroTeaser");
		ActiveHome.dataContainer.appendChild(heroWrapper);
		var heroRenderer= new ItemRender(heroWrapper,true);
		heroRenderer.render(hero);
	}

	protected static appendData(data: MagazineEntryDto[]){
		if(data.length > 0){
			var currentDate = new Date(data[0].date);
			var monthContainer = document.createElement("div");
			monthContainer.classList.add("_magazineHomeContainer");
			ActiveHome.dataContainer.appendChild(monthContainer);
			ActiveHome.itemRenderer = new ItemRender(monthContainer);
			for(var i = 0; i < data.length; i++){
				ActiveHome.itemRenderer.render(data[i]);
			}
		}
		Hyphenator.run();
	}

	protected static async loadData(){
		if(!ActiveHome.isLoading){
			ActiveHome.isLoading = true;
			var response = await RequestHelper.postJsonAndSpin(ActiveHome.requestUrl, ActiveHome.requestDto);
			ActiveHome.processResponse(response);
			ActiveHome.isLoading = false;
		}
	}

	protected static processResponse(res: IResponse){
		if(!res.requestError){
			var response = <IResponseWithData<MagazineHomeResponseDto>>res;
			var responseDto = <MagazineHomeResponseDto>response.data;
			if(responseDto.hero != null){
				ActiveHome.renderHero(responseDto.hero);
			}
			if(responseDto.entries.length > 0){
				var data = responseDto.entries;
				ActiveHome.appendData(data);
			}
		}else{
			ActiveHome.errorRenderer.render();
		}
		ImageOverlayHelper.init();
	}
}